module.exports = __webpack_public_path__ + "static/media/proper-design.fd79b96a.jpg";